import { useCallback, useState } from 'react';
import { ReferenceSearchCalendarDuration } from '@lt/api/dist/methods/references/types';
import { useGetApiClient } from '../../../context/apiContext';
import { SearchType } from '@lt/api/dist/types/searchParams';
import { format } from 'date-fns';
import { useIsMounted } from 'usehooks-ts';

export const useFetchReferencesSearchCalendarDuration = () => {
  const api = useGetApiClient();
  const isMounted = useIsMounted();
  const [searchCalendarDuration, setSearchCalendarDuration] = useState<
    ReferenceSearchCalendarDuration[]
  >([]);

  const changeSearchCalendarDurationParams = useCallback(
    async (
      start_date: Date,
      place_id: number,
      departure_id: number,
      adults: number,
      search_type: SearchType
    ) => {
      if (api) {
        setSearchCalendarDuration([]);
        const result = await api.getReferencesSearchCalendarDuration({
          start_date: format(start_date, 'yyyy-MM-dd'),
          place_id,
          departure_id,
          adults,
          search_type,
        });
        if (isMounted()) {
          setSearchCalendarDuration(result);
        }
      }
    },
    [api, isMounted]
  );

  return {
    searchCalendarDuration,
    changeSearchCalendarDurationParams,
  };
};
